export default "__VITE_ASSET__491d4b2f__"